// tslint:disable:max-line-length

import React from 'react';

export const ActionEnter = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 14" {...props}>
      <g id="Explorations" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="Performance-Summary-/-08-Copy-6"
          transform="translate(-743.000000, -382.000000)"
          fill="#000000"
          fillRule="nonzero"
        >
          <polygon id="Path" points="755 382 755 389 748 389 748 386 743 391 748 396 748 393 759 393 759 382" />
        </g>
      </g>
    </svg>
  );
};
